import _extends from "@babel/runtime/helpers/esm/extends";
var GRADIENT_STYLE = 'linear-gradient(180deg, rgba(18, 25, 38, 0.35) 0%, rgba(18, 25, 38, 0.7) 100%)';
export var getBackdropStyles = function getBackdropStyles(type, backgroundBlur, theme) {
  return _extends({}, type === 'default' && {
    backgroundColor: 'rgba(18, 25, 38, 0.7)'
  }, type === 'gradient' && {
    background: GRADIENT_STYLE
  }, type === 'invisible' && {
    background: 'transparent'
  }, backgroundBlur && {
    backdropFilter: "blur(".concat(theme.blurs.md, ")")
  });
};